import { FolderOutlined } from '@ant-design/icons';

import { Flex } from '@/components/base';
import type { TreeSelectItemBase } from '@/components/Select/types';
import service from '@/services/index';

const dashboardTreeFetcher = async (searchValue?: string) => {
  const res = await service.dashboard2.fetchDashboardTreeList(searchValue);
  const rootTopics: TreeSelectItemBase[] =
    res.dashboards?.map((d) => {
      return {
        alias: d.alias,
        node: <Flex>{d.title}</Flex>,
        searchValue: d.title,
      };
    }) || [];

  const folderPromises =
    res.dashboard_folders?.map((f) =>
      service.dashboard2.fetchDashboardsInFolder(f.alias),
    ) || [];
  const folderDashboards = await Promise.all(folderPromises);
  const folders: TreeSelectItemBase[] =
    res.dashboard_folders?.map((f, index) => {
      return {
        alias: f.alias,
        node: (
          <Flex a="center" g={4}>
            <FolderOutlined />
            {f.name}
          </Flex>
        ),
        searchValue: f.name,
        checkOption: {
          exceptSelf: true,
          disable: true,
        },
        childNodes:
          folderDashboards[index]?.dashboards?.map((d) => {
            return {
              alias: d.alias,
              node: <Flex>{d.title}</Flex>,
              searchValue: d.title,
            };
          }) || [],
      };
    }) || [];

  return [...folders, ...rootTopics];
};

export default dashboardTreeFetcher;
